import GradePage from "@/pages/GradePage";
export default function GradePreCalc() {
  return <GradePage grade="12" />;
}
